import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    '@keyframes dotBounce': {
        '0%, 60%, 100%': { opacity: 0.35, transform: 'translateY(0)' },
        '30%': { opacity: 1, transform: 'translateY(-4px)' },
    },
    typingDots: {
        alignItems: 'center',
        display: 'flex',
        gap: 4,
        height: 20,
    },
    typingDot: {
        animation: '$dotBounce 1.2s ease-in-out infinite',
        backgroundColor: theme.palette.secondary.main,
        borderRadius: '50%',
        height: 5,
        width: 5,
        '&:nth-child(2)': { animationDelay: '150ms' },
        '&:nth-child(3)': { animationDelay: '300ms' },
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
        },
    },
}));

const DOT_COUNT = 3;

export const AssistantTypingDots = () => {
    const classes = useStyles();
    return (
        <span className={classes.typingDots} aria-hidden="true">
            {Array.from({ length: DOT_COUNT }, (_, index) => (
                <span className={classes.typingDot} key={index} />
            ))}
        </span>
    );
};
